import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const taskCenterInfo = async (params: object) => {
  return await GET({ url: Api.taskCenterInfo, params, showError: false })
}

export const taskCenterV2 = async (params: object) => {
  return await GET({ url: Api.taskCenterV2, params, showError: false })
}

export const getPackageAward = async (params: object) => {
  return await GET({ url: Api.getPackageAward, params, showError: false })
}

export const getSubTaskAward = async (params: object) => {
  return await GET({ url: Api.getSubTaskAward, params, showError: false })
}

export const getTodayData = async (params: object) => {
  return await GET({ url: Api.getTodayData, params, showError: false })
}
